import { render, staticRenderFns } from "./ClmOpsImagem.vue?vue&type=template&id=a8c99b7c"
import script from "./ClmOpsImagem.vue?vue&type=script&lang=js"
export * from "./ClmOpsImagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports